export const DEFAULT_CHECKBOX_PROPS = {
    allRows: [],
    selectedRows: [],
    isAllSelected: false,
    isIndeterminate: false,
  };
   
  export interface GridCheckBoxState<T> {
    allRows: T[];
    selectedRows: T[];
    isAllSelected: boolean;
    isIndeterminate: boolean;
  }